import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';

export type Data<T> = Writable<T> & { get(): T };

/**
 * Create store
 */
export default function data<T>(initialValue: T): Data<T> {
  let value = initialValue;
  const originalWritable = writable<T>(value);

  /**
   * Set store value
   */
  function set(newValue: any) {
    return originalWritable.set((value = newValue));
  }

  /**
   * Update store value
   */
  function update(fn: (originalValue: T) => T) {
    originalWritable.update((oldValue: T) => (value = fn(oldValue)));
  }

  /**
   * Get store value
   */
  function get() {
    return value;
  }

  return { set, update, subscribe: originalWritable.subscribe, get };
}
